import { request } from '@langlois/request';

export async function invite ({ commit, dispatch }, {
	clubId,
	email
}) {
	const url = new URL(`${process.env.VUE_APP_API_URI}/club/member/invite`);

	const body = new FormData();

	for (let [key, value] of Object.entries({
		clubId,
		email
	})) {
		body.append(key, value);
	}

	let response;

	try {
		response = await request.post(url, body);

		const { ok } = response;

		if (!ok) return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while attempting to send out the invitation.`,
			type: `warning`
		}, { root: true });

		await dispatch(`getActiveInvitations`, clubId);

		commit(`vcl/notificationBar/show`, {
			text: `Invitation has been sent to ${email}.`,
			type: `success`
		}, { root: true });
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while attempting to send out the invitation.`,
			type: `warning`
		}, { root: true });
	}
}
